"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getBaseUrls = void 0;

var manualApiClientConfigs = _interopRequireWildcard(require("./config"));

var _getClients = require("./get-clients");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Check that the given environment is valid.
 */
var validateEnvironment = function validateEnvironment(environment) {
  var env = environment.toLowerCase();
  var validEnvironments = ['staging', 'preproduction', 'production'];

  if (validEnvironments.indexOf(env) < 0) {
    throw new TypeError("Unknown environment: must be one of ".concat(validEnvironments.join(', '), ", got \"").concat(env, "\""));
  }
};
/**
 * Get the base URL for the set environment.
 */


var getBaseUrl = function getBaseUrl(apiName, env) {
  var baseURLs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var apiClients = (0, _getClients.getClients)();
  var configs = Object.entries(apiClients).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        config = _ref2[1].config;

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, config));
  }, {});

  if (!(apiName in manualApiClientConfigs) && !(apiName in configs)) {
    throw new TypeError("Could not find a config file for API with name \"".concat(apiName, "\""));
  }

  var _ref3 = configs[apiName] || manualApiClientConfigs[apiName] || {},
      _ref3$environments = _ref3.environments,
      environments = _ref3$environments === void 0 ? {} : _ref3$environments,
      _ref3$settings = _ref3.settings;

  _ref3$settings = _ref3$settings === void 0 ? {} : _ref3$settings;
  var _ref3$settings$corsEn = _ref3$settings.corsEnabled,
      corsEnabled = _ref3$settings$corsEn === void 0 ? false : _ref3$settings$corsEn;
  validateEnvironment(env);
  var baseURL = corsEnabled ? environments[env] : baseURLs[apiName] || environments[env];

  if (!baseURL) {
    throw new Error("No base URL could be found for the \"".concat(apiName, "\" \"").concat(env, "\" environment"));
  }

  return baseURL;
};
/**
 * Get a map of baseURLs against api clients for the set environment.
 */


var getBaseUrls = function getBaseUrls(env) {
  var baseURLs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allClientKeys = [].concat(_toConsumableArray(Object.keys(manualApiClientConfigs)), _toConsumableArray(Object.keys((0, _getClients.getClients)())));
  return allClientKeys.reduce(function (acc, apiName) {
    var baseUrl = getBaseUrl(apiName, env, baseURLs);
    acc[apiName] = baseUrl;
    return acc;
  }, {});
};

exports.getBaseUrls = getBaseUrls;
var _default = getBaseUrl;
exports["default"] = _default;